/**
 * Todo priority
 * 
 * @var const priority
 */
export const priority = {
    low: 'success',medium: 'warning',high: 'error'
};